import { render, staticRenderFns } from "./u-file-input-outlined-tile.vue?vue&type=template&id=1a6c6133&scoped=true&"
import script from "./u-file-input-outlined-tile.vue?vue&type=script&lang=js&"
export * from "./u-file-input-outlined-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c6133",
  null
  
)

export default component.exports